export const HANDLING_CODES = {
  NOTHING_TO_DO: 1,
  FATAL: -1,
};
export const ERROR_PAGES = {
  DEFAULT: 'default',
  DEFAULT_MODAL: 'defaultModal',
  SHOP: 'shop',
};

export const WEB_SERVICES = {
  SET_INFO: 'setInfoBaf',
  SEND_SMS_OTP: 'sendSmsOtp',
  VALIDATE_SMS_OTP: 'validateSmsOtp',
  PROGRESS_OTP: 'progressOtp',
  PROGRESS_OBD: 'progressObd',
};
